module.exports = __webpack_public_path__ + "static/cloudscann-s-003f2c04364cb4c726f7eb161f667ef6.png";